import React, { useState } from 'react';
import { Avatar, Box, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';

const MemberAvatar = ({ image, name, size = 36 }) => {
  const { colors: appColors } = useAppTheme();
  const [open, setOpen] = useState(false);

  const initials = name
    ? name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <>
      <Avatar
        src={image || undefined}
        onClick={image ? (e) => { e.stopPropagation(); setOpen(true); } : undefined}
        sx={{
          width: size,
          height: size,
          bgcolor: appColors.evergreen,
          fontSize: size * 0.38,
          fontWeight: 700,
          cursor: image ? 'zoom-in' : 'default',
          border: '2px solid #e5e7eb',
          flexShrink: 0,
          transition: 'transform 0.15s',
          '&:hover': image ? { transform: 'scale(1.08)', borderColor: appColors.evergreen } : {},
        }}
      >
        {!image && initials}
      </Avatar>

      {/* Zoom modal */}
      <Modal open={open} onClose={() => setOpen(false)} onClick={() => setOpen(false)}>
        <Box sx={{
          position: 'fixed', inset: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          bgcolor: 'rgba(0,0,0,0.75)',
        }}>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: 'absolute', top: 16, right: 16, color: 'white', bgcolor: 'rgba(0,0,0,0.4)' }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            component="img"
            src={image}
            alt={name}
            onClick={(e) => e.stopPropagation()}
            sx={{
              maxWidth: '90vw',
              maxHeight: '85vh',
              borderRadius: 3,
              boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default MemberAvatar;
